import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Button } from "antd";
import { useSize } from "ahooks";

import erpDirection from "../../assets/images/erpDirection.jpg";
import eCommerce from "../../assets/images/eCommerce.jpg";
import webApp from "../../assets/images/webApp.jpg";
import plugins from "../../assets/images/plugins.jpg";
import aboutProject1 from "../../assets/images/aboutProject1.jpg";
import aboutProject2 from "../../assets/images/aboutProject2.jpg";
import photoBackground from "../../assets/images/background.jpg";
import videoBackground from "../../assets/video/Animation.mp4";
import { Contacts } from "./Contacts";
import { useTranslation } from "react-i18next";
import styles from "./Home.module.scss";
import AnimatedBlock from "./AnimatedBlock";

interface MainDirections {
  name: string;
  image: string;
  alt: string;
}

export const Home: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const size = useSize(document.querySelector("body"));

  function handleGoTo(filterName: string, filterValue: string) {
    navigate({
      pathname: "/portfolio/",
      search: `?${filterName}=${filterValue}`
    });
  }
  const mainDirectionsArray: MainDirections[] = [
    { name: "ERP", image: erpDirection, alt: "erp" },
    { name: "E-commerce", image: eCommerce, alt: "eCommerce" },
    { name: "Web Application", image: webApp, alt: "web application" },
    { name: "CRM", image: plugins, alt: "crm" }
  ];

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.mainTextBlock}>
          <div className={styles.mainText}>HaltenTech</div>
          <div className={styles.description}>{t("home.description")}</div>
        </div>

        <video autoPlay muted loop playsInline>
          <source src={videoBackground} type="video/mp4" />
        </video>
      </div>

      <div className={styles.aboutBlock}>
        <div>
          <Row>
            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <div className={styles.aboutMainText}>
                {t("home.about.mainTitle")}
              </div>
              <div className={styles.aboutText}>{t("home.about.mainText")}</div>
              {size?.width! > 1025 && (
                <Link to="/portfolio">
                  <Button className={styles.portfolioButton}>
                    {t("buttons.portfolio")}
                  </Button>
                </Link>
              )}
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }}>
              <Row gutter={[24, 40]}>
                <Col span={12}>
                  <div className={styles.columnTitle}>
                    {t("home.about.highQualityTitle")}
                  </div>
                  <div className={styles.columnText}>
                    {t("home.about.highQualityText")}
                  </div>
                </Col>
                <Col span={12}>
                  <div className={styles.columnTitle}>
                    {t("home.about.modernTechnologiesTitle")}
                  </div>
                  <div className={styles.columnText}>
                    {t("home.about.modernTechnologiesText")}
                  </div>
                </Col>
                <Col span={12}>
                  <div className={styles.columnTitle}>
                    {t("home.about.complexProjectsTitle")}
                  </div>
                  <div className={styles.columnText}>
                    {t("home.about.complexProjectsText")}
                  </div>
                </Col>
                <Col span={12}>
                  <div className={styles.columnTitle}>
                    {t("home.about.innovativeSolutionsTitle")}
                  </div>
                  <div className={styles.columnText}>
                    {t("home.about.innovativeSolutionsText")}
                  </div>
                </Col>
              </Row>
            </Col>
            {size?.width! <= 1025 && (
              <Col span={24}>
                <Link to="/portfolio">
                  <Button className={styles.portfolioButton}>
                    {t("buttons.portfolio")}
                  </Button>
                </Link>
              </Col>
            )}
          </Row>

          {size?.width! > 576 && (
            <Row className={styles.dotsBlock} justify="space-between">
              {Array.from(Array(7).keys()).map((v) => (
                <Col key={v}>
                  <div className={styles.dot} />
                </Col>
              ))}
            </Row>
          )}
        </div>
      </div>

      <div className={styles.mainDirectionsBlock}>
        <div className={styles.mainDirectionsBlockWrapper}>
          <div className={styles.mainDirectionsTitle}>
            {t("home.mainDirections")}
          </div>
          <Row justify="space-between" gutter={{ xs: 16, lg: 48 }}>
            {mainDirectionsArray.map((v) => {
              return (
                <AnimatedBlock
                  data={v}
                  handleGoTo={() => handleGoTo("type", v.name)}
                />
              );
            })}
          </Row>
        </div>
      </div>

      {size?.width! > 576 && (
        <img
          src={photoBackground}
          alt="Programer is working"
          className={styles.mainDirectionsBackground}
        />
      )}

      <div className={styles.aboutWorkBlock}>
        <Row gutter={40} className={styles.aboutWorkBlockRow}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 10 }}
            md={{ span: 10 }}
            lg={{ span: 10 }}
          >
            <div className={styles.aboutWorkSubtitle}>
              {t("home.about.aboutWorkSubtitle")}
            </div>
            <div className={styles.aboutWorkTitle}>
              {t("home.about.aboutWorkTitle")}
            </div>
            <div className={styles.aboutWorkText}>
              {t("home.about.aboutWorkText")}
            </div>

            <Link to="/portfolio">
              <Button className={styles.aboutBlockPortfolioButton}>
                {t("buttons.portfolio")}
              </Button>
            </Link>
          </Col>
          <Col
            sm={{ span: 14 }}
            md={{ span: 14 }}
            xs={{ span: 24 }}
            lg={{ span: 14 }}
          >
            <Row
              align="bottom"
              justify={size?.width! > 991 ? "end" : "center"}
              wrap={false}
            >
              <img
                src={aboutProject1}
                className={styles.photoAboutProject}
                alt="App screenshot"
              />

              <img
                src={aboutProject2}
                className={styles.photoAboutProject}
                alt="App screenshot"
              />
            </Row>
          </Col>
        </Row>
      </div>

      <Contacts />
    </div>
  );
};
